// extracted by mini-css-extract-plugin
export default {"stepsSection":"StepsSection__stepsSection-xKxv","title":"StepsSection__title-tL5t"};